<template>
  <div>
    <!-- <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" /> -->
    <span @click="url" class="text-inherit hover:text-primary cursor-pointer">{{ params.value }}</span>
  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'

export default {
  name: 'CellRendererLink',
  methods: {
    async url () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      try {
        if (!operacionesStore.isRegistered) {
          this.$store.registerModule('operacionesStore', operacionesStore)
          operacionesStore.isRegistered = true
        }

        await this.$store.dispatch('operacionesStore/getOperacion', this.params.data.id)
          .then((response) => {
            this.operacion = response.data
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          })
          .catch(
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          )
      } catch (error) {
        console.error(error)
      }
      const ruta = `/gestion/operaciones/ver/${this.params.data.id}`
      this.$router.push(ruta).catch(() => {})
    }
  }
}
</script>
